<!--
 * @Author: your name
 * @Date: 2020-10-16 09:54:46
 * @LastEditTime: 2021-02-02 11:03:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \1-trunk\src\views\mdt-consult\apply\schedule-team-list.vue
-->
<template>
  <div class="scheduleteamlist">
    <van-nav-bar title="选择会诊团队" left-arrow>
      <template #left>
        <div @click="$router.go(-1)">
          <i class="iconfont iconbtn_24_back"></i>
        </div>
      </template>
    </van-nav-bar>

    <div class="listBody" v-for="(item, key) in team" :key="key">
      <div class="item" @click="chooseTeam(item.teamId,item.teamName,item.consultId)">
        <p>{{item.teamName}}</p>
        <van-icon name="arrow" class="icon" />
        <p>{{item.member}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      teamObj: [],
      team: [],
      teamMember: []
    }
  },
  created () {
    this.teamObj = this.$route.query.team
    this.getTeam()
  },
  methods: {
    // 重组团队数组
    getTeam () {
      this.teamObj.forEach(item => {
        this.getTeamMember(item.TeamMemberId, item.Name, item.ID, item.ConsultId)
      })
    },
    // 根据id获取团队成员
    getTeamMember (id, name, teamId, consultId) {
      this.$axios.post('api/consult/detail/get/team/member', {
        version: this.$version,
        data: { id: id }
      }).then(res => {
        if (res.status) {
          var member = []
          res.data.members.forEach(item => {
            member.push(item.trueName)
          })
          this.team.push(
            {
              teamName: name,
              member: member.join(','),
              teamId: teamId,
              consultId: consultId
            }
          )
        }
      })
    },
    // 选定团队
    chooseTeam (teamId, name, consultId) {
      this.$router.push({
        path: '/creatconsult',
        query: {
          teamId: teamId,
          teamName: name,
          consultId: consultId,
          businessShowName: this.$route.query.businessShowName
        }
      })
    }
  },
  watch: {},
  computed: {},
  components: {}
};
</script>
 <style lang="scss" scoped>
.scheduleteamlist {
  position: fixed;
  top: 52px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background-color: $white;
  .listBody {
    .item {
      position: relative;
      padding: 10px 15px;
      p {
        line-height: 20px;
      }
      .icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 15px;
        color: $grey969799;
        font-weight: 700;
      }
    }
  }
}
</style>
